import { createApp } from "vue";
import axios from "axios";

// Locations map
import LocationsMap from './LocationsMap/LocationsMap.vue';

const app = createApp(LocationsMap);

app.config.globalProperties.$axios = axios;

app.mount("#locations-map");